import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import * as styles from './product-info-price-ds.styles'

export interface PerUnitOfferRowProps {
  festivalPricePerUnit?: number
  subscriptionOfferPricePerUnit?: number
  // Raw `purchaseOption === SUBSCRIBE`; unlike offer-value selection it does NOT require
  // `formattedSubscriptionPrice`, matching legacy.
  isSubscribePurchase: boolean
  traditionalPricePerServing?: number
  unitForPerServing: string
}

// Festival/subscription per-unit vs traditional-retail row; subscription per-unit price wins when subscribing.
function PerUnitOfferRow({
  festivalPricePerUnit,
  subscriptionOfferPricePerUnit,
  isSubscribePurchase,
  traditionalPricePerServing,
  unitForPerServing,
}: PerUnitOfferRowProps) {
  const { t } = useTranslation('common')
  return (
    <div className={cx(styles.priceWrapperMainTextCss, styles.priceWrapperMainTextNewDesignV2Css)}>
      <span className={styles.priceWrapperMainValuePerservingTraditionalCss}>
        <FormattedPrice amount={traditionalPricePerServing} />
      </span>{' '}
      <FormattedPrice
        amount={
          subscriptionOfferPricePerUnit && isSubscribePurchase
            ? subscriptionOfferPricePerUnit
            : festivalPricePerUnit
              ? festivalPricePerUnit
              : ''
        }
      />
      /{t('per_unit_vs_traditional_retail', { value: unitForPerServing })}
    </div>
  )
}

export default PerUnitOfferRow
